<template>
  <div class="page-set-container">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="全局设置" name="1">
        <div class="setting-item clearFloat">
          <div class="verticallyCenter">
            <span class="fs14 mr16">内容区宽度</span>
            <el-select v-model="pageWidth" class="mr8 percent58 height32 flex1">
              <el-option
                v-for="(item, index) in pageWidthList"
                :key="index"
                :selected="pageWidth == item.value"
                :value="item.value"
                :label="item.title"
                >{{ item.title }}
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="外观" name="2">
        <div class="content-item verticallyCenter mb16">
          <span class="fs14 mr16">主题色</span>
          <div class="color-picker-container flex1">
            <el-color-picker
              class="floatLeft"
              v-model="themeColor"
              @active-change="activeChangeColor"
            ></el-color-picker>
            <span class="floatLeft color-text">{{ themeColor }}</span>
          </div>
        </div>
        <div class="content-item mb16">
          <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
        </div>
        <cx-background :background.sync="background" class="mt16" imgType="10" />
      </el-collapse-item>
      <el-collapse-item title="显示设置" name="3">
        <div class="content">
          <div class="content-item mb16">
            <cx-check-box :value.sync="showNavMenu">显示导航</cx-check-box>
            <!--                        <div v-if="showNavMenu">-->
            <!--                            <div class="mb16 fs14">显示位置</div>-->
            <!--                            <el-radio-group v-model="navMenuDisplayPosition">-->
            <!--                                <el-radio-->
            <!--                                        v-for="(option, index3) in navMenuDisplayPositionList"-->
            <!--                                        :key="index3"-->
            <!--                                        :label="option.label"-->
            <!--                                >{{ option.title }}</el-radio-->
            <!--                                >-->
            <!--                            </el-radio-group>-->
            <!--                        </div>-->
          </div>
          <div class="content-item mb16">
            <cx-check-box :value.sync="showApplicationName">显示应用名称</cx-check-box>
          </div>
          <!--                    <div class="content-item mb16">-->
          <!--                        <cx-check-box :value.sync="showSearchComponent">显示列表页搜索</cx-check-box>-->
          <!--                    </div>-->
          <div class="content-item mb16">
            <cx-check-box :value.sync="showBreadCrumbs">显示面包屑</cx-check-box>
          </div>
          <!--                    <div class="content-item mb16">-->
          <!--                        <cx-check-box :value.sync="showHeadFoot">显示头底</cx-check-box>-->
          <!--                    </div>-->
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: "listPage-set",
  data() {
    return {
      activeNames: ["1"],
      activeName: "first",
      pageWidthList: [
        {
          value: 800,
          title: "800px"
        },
        {
          value: 1000,
          title: "1000px"
        },
        {
          value: 1200,
          title: "1200px"
        },
        {
          value: 1400,
          title: "1400px"
        },
        {
          value: 1600,
          title: "1600px"
        }
      ],
      navMenuDisplayPositionList: [
        {
          title: "侧边",
          label: "left"
        },
        {
          title: "顶部",
          label: "top"
        }
      ]
    }
  },
  computed: {
    pageWidth: {
      get() {
        let flag = this.$store.state[this.request_prefix].page.pageWidth
        if (typeof flag === "undefined") {
          flag = 1920
          this.$changePageAttribute({ option_name: "pageWidth", option_val: flag }, true)
        }
        return flag
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "pageWidth", option_val: newVal })
      }
    },
    themeColor: {
      get() {
        let flag = this.$store.state[this.request_prefix].page.themeColor
        if (typeof flag === "undefined") {
          flag = "#3D82F2"
          this.$changePageAttribute({ option_name: "themeColor", option_val: flag }, true)
        }
        return flag
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "themeColor", option_val: newVal })
      }
    },
    opacity: {
      get() {
        let globalBgSetting = this.$store.state[this.request_prefix].page.globalBgSetting
        return globalBgSetting && globalBgSetting.hasOwnProperty("opacity") ? globalBgSetting.opacity : 100
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.opacity", option_val: newVal })
      }
    },
    background: {
      get() {
        let background = this.checkAndSetPrimaryVal(
          this.$store.state[this.request_prefix].page.globalBgSetting,
          "background",
          "background",
          []
        )
        if (background && Array.isArray(background) && background.length > 0) {
          return this.$store.state[this.request_prefix].page.globalBgSetting.background
        }
        let newBackground = []
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.colorType === "纯色" ? this.color : "rgba(0,0,0,0)"
        })
        if (this.colorType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.colorlinearGradientAngle,
              stops: [
                [this.startColor, 0],
                [this.endColor, 1]
              ]
            }
          })
        }
        if (this.imgUrl) {
          newBackground.push({
            type: "img",
            label: "图片",
            imgUrl: this.imgSrc,
            clipSize: this.clipSize,
            repeatType: this.repeatType,
            alignType: this.alignType,
            opacity: 100
          })
        }
        this.$changePageAttribute({ option_name: "globalBgSetting.background", option_val: newBackground }, true)
        return newBackground
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.background", option_val: newVal })
      }
    },
    showNavMenu: {
      get() {
        return this.$store.state[this.request_prefix].page.listPageSetting.showNavMenu
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeListPageSetting", { key: "showNavMenu", data: newVal })
      }
    },
    navMenuDisplayPosition: {
      get() {
        return this.$store.state[this.request_prefix].page.listPageSetting.navMenuDisplayPosition
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeListPageSetting", {
          key: "navMenuDisplayPosition",
          data: newVal
        })
      }
    },
    showApplicationName: {
      get() {
        return this.$store.state[this.request_prefix].page.listPageSetting.showApplicationName
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeListPageSetting", {
          key: "showApplicationName",
          data: newVal
        })
      }
    },
    openListPageSwitch: {
      get() {
        return this.$store.state[this.request_prefix].page.listPageSetting.openListPageSwitch
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeListPageSetting", {
          key: "openListPageSwitch",
          data: newVal
        })
      }
    },
    showSearchComponent: {
      get() {
        return this.$store.state[this.request_prefix].page.listPageSetting.showSearchComponent
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeListPageSetting", {
          key: "showSearchComponent",
          data: newVal
        })
      }
    },
    showBreadCrumbs: {
      get() {
        return this.$store.state[this.request_prefix].page.listPageSetting.showBreadCrumbs
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeListPageSetting", { key: "showBreadCrumbs", data: newVal })
      }
    },
    showHeadFoot: {
      get() {
        return this.$store.state[this.request_prefix].page.listPageSetting.showHeadFoot
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeListPageSetting", { key: "showHeadFoot", data: newVal })
      }
    }
  },
  mounted() {
    this.screenWidth = window.screen.width
  },
  methods: {
    activeChangeColor(val) {
      this.themeColor = val
    }
  }
}
</script>

<style lang="scss" scoped>
.page-set-container {
  color: rgba(0, 0, 0, 0.8);
  .title {
    position: relative;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.8);
  }
  .recover-btn {
    color: var(--themeColor);
  }
  .tips {
    color: rgba(0, 0, 0, 0.4);
  }
}
</style>
